import axiosInstance from "@/api/axios-instance";

export async function refreshDrugCache() {
  try {
    const response = await axiosInstance.post("/prescriptions/refresh-drug-cache");
    return response.data;
  } catch (error: any) {
    console.error("Error refreshing drug cache:", error);
    throw new Error(
      error.response?.data?.message ||
      error.message ||
      "Failed to refresh drug database cache"
    );
  }
}
